export const MODEL_GROUPS_QK = 'modelGroups';
export const ORION_MODEL_OPTIONS_QK = 'orionModelOptions';

export const queryKeys = {
  modelGroups: (clientId?: number) => [MODEL_GROUPS_QK, clientId],
  orionModelOptions: () => [ORION_MODEL_OPTIONS_QK],
};
